import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

/**
 * First button should perform the main action;
 * the second - an auxiliary one.
 */
class AlertDialog extends React.Component {

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">

                <DialogTitle id="alert-dialog-title">{this.props.dialogTitle}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {this.props.dialogContent}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {
                        this.props.firstButtonText &&
                        <Button onClick={this.props.firstButtonClick} color="secondary">
                            {this.props.firstButtonText}
                        </Button>
                    }
                    {
                        this.props.secondButtonText &&
                        <Button onClick={this.props.secondButtonClick} color="primary">
                            {this.props.secondButtonText}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default AlertDialog;